import moment from 'moment'

export default {
  type: 'U',
  render: (value) => moment(value).format('LLLL'),
  compare: (a, b) => a - b
}
